import { SelectedMutations } from '@feedyou/utils'
import { RootState } from '../../reducers'

export function getSelectedMutationsSelector(state: RootState): SelectedMutations {
  return state?.selectedMutations
}
